import { isNativeRuntime } from '@/lib/runtime';

export async function openExternalUrl(url) {
  if (!url) return;

  if (isNativeRuntime()) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    } catch (error) {
      console.warn('Falling back to window.open for external URL', error);
    }
  }

  if (typeof window !== 'undefined') {
    window.location.href = url;
  }
}
